<!--
  -  Copyright (c) Qwoach LLC 2020. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 01/01/2019
  -->


<template>
	<div>

<!--		<div v-if="isDataLoading" v-loading="isDataLoading" element-loading-text="Loading Programs..." class="empty-loading-placeholder">-->

<!--		</div>-->
		<div>
			<div class="col px-0">
				<div class="px-3 pb-4">
					<h4 style="font-weight: 500" class="mb-4">Setup your personal URL</h4>
					<p>This is your personal scheduling URL that people will see when they book a session with you. Put your name or brand so people can recognize you.
					</p>
<!--					<div class="text-center">-->
<!--						<img src="@/assets/images/scheduler_url.png" style="width: 446px;" class=""/>-->
<!--					</div>-->

				</div>

				<div class="col no-select">

					<div>
						<hr class="m-0 pb-5"/>

						<div class="mb-5">
							<h5 class="pb-2" style="font-size:1em; font-weight: 600">Your personal scheduling URL</h5>
							<div class="justify-content-center px-3"
								 :class="{'vertical-center': smUp, row:smUp, col:!smUp}">
								<el-form :model="form" :rules="rules" label-position="right" ref="mainForm" class="pb-4 w-100" @submit.native.prevent="submitForm()">
									<el-form-item prop="schedulingUrl" style="border: none" class="w-100">
									<el-input placeholder="your-url (ex. your name or brand)" v-model="form.schedulingUrl" class="pb-2" @focus="clearFormValidation">
										<template #prepend>qwoach.com/</template>
									</el-input>
									</el-form-item>
								</el-form>
							</div>

						</div>

					</div>


				</div>
			</div>

		</div>


	</div>
</template>

<script>

	import WizardBaseStep from "./WizardBaseStep"
	import moment from 'moment-timezone/builds/moment-timezone-with-data-10-year-range.min'
    import {logError, userTimezone} from "@/utils/helpers";

	export default {
		extends: WizardBaseStep,
		components: {

		},
		data() {
			return {

				form: {
					schedulingUrl: '',
					timeZone:''
				},
				rules: {
					schedulingUrl: [
						{ required: true, whitespace:false, message: 'Please enter your personal URL', trigger: 'validate'},
						{ validator:(rule, value, callback, source, options) => {
							let error;
							if(value.length > 0 && !this.urlPattern.test(value)){
								console.log("value = ", value)
								error = 'Pleas only use lowercase letters, numbers and "-"'
							}
							if(error){
								return callback(error)
							}
							this.showProgress()
							return this.$dataManager.schedulerIsRootUrlFree(value)
								.then(isFree => {
									console.log("isFree = ", isFree)
									return isFree ? undefined : 'This URL is already taken. Please use a different one.';
								})
								.then(callback)
								.catch(error => {
									this.hideProgress();
									logError(error)
									callback('Something went wrong. Please try again later.')
								})


							},
							trigger: 'validate'
						}
					],

				},

			};
		},
		computed:{
			smUp(){
				return true
			},
			wizardStepPercentage(){
				return this.step / this.stepCount * 100
			},
			urlValidCharacters(){
				return 'a-z0-9-'
			},
			urlPattern(){
				return new RegExp('^[' + this.urlValidCharacters + ']+$')
			}
		},
		created () {
			let email = this.currentUser.email || "";
			let emailName = email.split("@")[0] || ""
			emailName = emailName.toLowerCase().replaceAll("[^" + this.urlValidCharacters + "]", "-")
			this.form.schedulingUrl = emailName;
			this.form.timeZone = userTimezone()
		},
		methods: {

			submitForm(){
				this.$refs.mainForm.validate(isValid => {
					this.hideProgress()
					if (isValid){
						this.onFormValidated();
					}
				})
			},
			clearFormValidation(){
				this.$refs.mainForm.clearValidate();
			},
			onNextClicked(){
				this.submitForm()
			},
			onFormValidated(){
				this.clearFormValidation();
				this.userProfile.schedulerSettings.eventTypeUserId = this.form.schedulingUrl;
				this.userProfile.schedulerSettings.timeZone = this.form.timeZone;
				this.showProgress()
				return this.$authManager.updateUserProfile(this.userProfile)
					.then(() => {
						this.onNextConfirmed()
					}).catch(error => {
						this.handleError(error, "Something went wrong. Please try again later.")
						this.hideProgress();
					})
			},

		},

	}
</script>

<style src="../Scheduler.scss" lang="scss" scoped/>
